function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12z",
  fill: "#201D1A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M19.11 7c.49 0 .89.354.89.786 0 .432-.4.786-.89.786h-1.777v7.073c0 1.446-1.459 2.577-3.148 2.318-1.076-.165-1.956-.943-2.143-1.894-.293-1.493.987-2.782 2.623-2.782.311 0 .614.055.89.141V8.572c0-.865.8-1.572 1.778-1.572zm-8.985 6c.481 0 .875.45.875 1s-.394 1-.875 1h-5.25C4.394 15 4 14.55 4 14s.394-1 .875-1zm3.042-3c.458 0 .833.45.833 1s-.375 1-.833 1H4.833C4.375 12 4 11.55 4 11s.375-1 .833-1zm0-3c.458 0 .833.45.833 1s-.375 1-.833 1H4.833C4.375 9 4 8.55 4 8s.375-1 .833-1z"
});

var SvgStems = function SvgStems(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStems, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stems.9c685579.svg";
export { ForwardRef as ReactComponent };